// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialMediaFields_root__RYAVg"};